import React from 'react';
import Listings from '../components/Listings';

const Realisations = () => {
  return <Listings />;
};

export default Realisations;